import { Form, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { transferToQC } from "../../../../redux/EngageTranslation/EngageTranslationAction";
import { useState } from "react";

const TransferToQCModal = (props: any) => {
  const [comments, setComments] = useState("");
  const transferState = useSelector((state: any) => state.engageTranslationState.viewDocumentPageState);
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  async function handleChange() {
    await dispatch(transferToQC({ documentId: props.documentId, comments: comments }));
    props.close();
    props.openTransferToQCConfirmation();
  }

  return (
    <Modal
      centered
      width={700}
      confirmLoading={transferState.loading}
      zIndex={10000}
      onOk={() => {
        form.submit();
      }}
      destroyOnClose={true}
      afterClose={() => {
        form.resetFields();
      }}
      onCancel={() => {
        props.close();
      }}
      open={props.openState}>
      <h4 className="mb-4">Transfer to QC</h4>
      <div className="d-flex flex-column gap-1">
        <div className="d-flex flex-column gap-2">
          <Form
            form={form}
            onFinish={() => {
              handleChange();
            }}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}>
            <Form.Item
              label="Comment"
              name="comment"
              rules={[
                {
                  required: true,
                  message: "Please input your comment.",
                },
              ]}>
              <TextArea
                rows={3}
                placeholder="Please input your comment."
                showCount
                maxLength={100}
                onChange={(e) => setComments(e.target.value)}
              />
            </Form.Item>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default TransferToQCModal;
